export default function cookieReducers(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
